import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { StrictMode } from 'react';
import { PostHogProvider } from 'posthog-js/react';

const apiKey = 'phc_PAsiZbnDka0Kz3tyiGJ4D6Yby2iRoXfV8lby0Osdl3G';
const posthogOptions = {
    api_host: 'https://eu.i.posthog.com',
}

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <PostHogProvider apiKey={apiKey} options={posthogOptions}>
            <App />
        </PostHogProvider>
    </StrictMode>
);
